import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudCog = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c.956 0 1.822 .39 2.449 1.02" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.001 15.5v1.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.001 21v1.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M22.032 17.25l-1.299 .75" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.27 20l-1.3 .75" }),
		/* @__PURE__ */ _jsx("path", { d: "M15.97 17.25l1.3 .75" }),
		/* @__PURE__ */ _jsx("path", { d: "M20.733 20l1.3 .75" })
	]
});
const ForwardRef = forwardRef(SvgCloudCog);
export default ForwardRef;
